// extracted by mini-css-extract-plugin
export default {"success__header-title":"InfoAlert_success__header-title__+RBZ7","success__header-icon":"InfoAlert_success__header-icon__1SoXO","success__content":"InfoAlert_success__content__796P7"};